import {CBTextureLoader, CBTextureLoadError, getGlobalCanvas} from "./CBTextureLoader";
import * as THREE from "three";
import {CBTextureType} from "./CBTypes";
import {CanvasContext} from "react-three-fiber";

export class CBMaterialProperties {

    constructor(public readonly ppi:number,
                public readonly diffuseUrl:string,
                public readonly normalsUrl?:string,
                public readonly specularUrl?:string) {

    }
}

let _swap = 0;

export class CBMaterial {

    private readonly _diffuseLoader:CBTextureLoader;
    private readonly _normalsLoader:CBTextureLoader;
    private readonly _specularLoader:CBTextureLoader;

    constructor(public readonly props:CBMaterialProperties, public readonly canvasID:string, public readonly context:CanvasContext, public swapOffscreen=false) {
        this._diffuseLoader = new CBTextureLoader(context);
        this._normalsLoader = new CBTextureLoader(context);
        this._specularLoader = new CBTextureLoader(context);
    }

    public width:number = 0;
    public height:number = 0;

    private _numNotLoaded = 0;

    public diffuseTexture:THREE.Texture | null = null;
    public normalsTexture:THREE.Texture | null = null;
    public specularTexture:THREE.Texture | null = null;

    public load(onLoad: () => void,
                onError: (event: CBTextureLoadError) => void) {

        this._numNotLoaded = 1;
        if (this.swapOffscreen) {
            _swap = (_swap ++) % 2;
        }

        this._diffuseLoader.load(CBTextureType.Material, this.props.diffuseUrl,
            getGlobalCanvas(this.canvasID + "-diffuse" + _swap),
            (texture:THREE.Texture, width:number, height:number) => {
                this.diffuseTexture = texture;
                this.width = width;
                this.height = height;
                this._numNotLoaded --;
                this.maybeOnLoad(onLoad);
                //console.log(`Canvas created at ${width}x${height}, max is ${this.context.gl.capabilities.maxTextureSize}`)
            }, undefined, onError);

        if (this.props.normalsUrl && this.props.specularUrl) {
            this._numNotLoaded += 2;
            this._normalsLoader.load(CBTextureType.Material, this.props.normalsUrl,
                getGlobalCanvas(this.canvasID + "-normals" + _swap),
                (texture:THREE.Texture) => {
                    this.normalsTexture = texture;
                    this._numNotLoaded --;
                    this.maybeOnLoad(onLoad)
                }, undefined, ()=> {
                    this._numNotLoaded --
                });

            this._specularLoader.load(CBTextureType.Material, this.props.specularUrl,
                getGlobalCanvas(this.canvasID + "-specular" + _swap),
                (texture:THREE.Texture) => {
                    this.specularTexture = texture;
                    this._numNotLoaded --;
                    this.maybeOnLoad(onLoad)
                }, undefined, ()=> {
                    this._numNotLoaded --
                })
        }
    }

    private maybeOnLoad(onLoad:() => void) {
        if (!this._numNotLoaded) {
            onLoad()
        }
    }

    public dispose() {

        if (this._diffuseLoader) {
            this._diffuseLoader.dispose()
        }
        if (this._normalsLoader) {
            this._normalsLoader.dispose()
        }
        if (this._specularLoader) {
            this._specularLoader.dispose()
        }

        if (this.diffuseTexture) {
            this.diffuseTexture.dispose();
            this.diffuseTexture = null
        }
        if (this.normalsTexture) {
            this.normalsTexture.dispose();
            this.normalsTexture = null
        }
        if (this.specularTexture) {
            this.specularTexture.dispose();
            this.specularTexture = null
        }
    }
}
